import { useCallback } from 'react';
import { IChatSendMessage } from 'src/@types/chat';
import { ConversationMessageContentType } from 'src/@types/conversation';
import { useConversationMediaUpload } from 'src/hooks/useConversationMediaUpload';
import { sendMessage } from 'src/redux/slices/chat';
import { useDispatch } from 'src/redux/store';

/**
 * @deprecated use useSendChannelMessage instead
 */
export const useSendMessage = (conversationId: string) => {
  const { uploadMediaFile } = useConversationMediaUpload();

  const dispatch = useDispatch();

  const handleSendMessage = useCallback(
    (value: IChatSendMessage) => {
      try {
        dispatch(sendMessage(value));
      } catch (error) {
        console.error(error);
      }
    },
    [dispatch],
  );

  const handleFileSelect = useCallback(
    async (file: File) => {
      const { _id, mimeType, size, name } = await uploadMediaFile(file);

      return {
        mediaRef: _id,
        channel: conversationId,
        mimeType,
        fileName: name,
        fileSize: size,
      };
    },
    [conversationId, uploadMediaFile],
  );

  const handleTextMessage = useCallback(
    (message: string) => ({
      content: message,
      channel: conversationId,
      contentType: ConversationMessageContentType.TEXT,
    }),
    [conversationId],
  );

  return {
    handleTextMessage,
    handleFileSelect,
    handleSendMessage,
  };
};
